import React from 'react';
import { Outlet } from 'react-router-dom'; 

const MinimalLayout = ({ children }) => {
  return (
    <div className="login-wrapper">
      <div className="container-center">
        <Outlet /> 
      </div>
    </div>
  );
};

export default MinimalLayout;
